import { EventEmitter, Injectable, Output } from "@angular/core";

export interface ActiveEventMessage {
    active: boolean;
    filterId: string;
    value?: string;
}

@Injectable({ providedIn: 'root' })
export class DataTableFilterMessageService {
 
    @Output() applyEvent = new EventEmitter<string>();
    @Output() clearEvent = new EventEmitter<string>();
    @Output() clickoutEnabledEvent = new EventEmitter<boolean>();
    @Output() activeEvent = new EventEmitter<ActiveEventMessage>();

    onApplyClicked(filterId: string): void {
        this.applyEvent.emit(filterId);
    }

    onClearClicked(filterId: string): void {
        this.clearEvent.emit(filterId);
    }

    setClickoutEnabled(enabled: boolean) {
        this.clickoutEnabledEvent.emit(enabled);
    }

    setActive(message: ActiveEventMessage) {
        this.activeEvent.emit(message);
    }
}